// การแปลภาษาไทย
export const th = {
  title: 'HandinCap',
  subtitle: 'สกอร์การ์ดของคุณ',
  create: 'สร้างเกมใหม่',
  courseTitle: 'ตั้งค่าสนาม',
  autoMode: 'ค้นหาอัตโนมัติ',
  manualMode: 'กรอกเอง',
  searchPlaceholder: 'ค้นหาชื่อสนาม...',
  selectCourse: 'เลือกสนาม',
  gameType: 'ประเภทเกม',
  setPar: 'ตั้งค่า PAR',
  confirmCourse: 'ยืนยัน',
  playerTitle: 'ตั้งค่าผู้เล่น',
  players: 'ผู้เล่น',
  player1: 'ผู้เล่น 1',
  player2: 'ผู้เล่น 2',
  player3: 'ผู้เล่น 3',
  player4: 'ผู้เล่น 4',
  player5: 'ผู้เล่น 5',
  player6: 'ผู้เล่น 6',
  player7: 'ผู้เล่น 7',
  player8: 'ผู้เล่น 8',
  enterName: 'กรอกชื่อ',
  gameMode: 'โหมดเกม',
  matchPlay: 'Match Play',
  win123: 'Win123',
  skins: 'Skins',
  baccarat: 'บาคาร่า',
  stake: 'เดิมพัน',
  prizePool: 'เงินรางวัล',
  penaltyPot: 'เงินปรับ',
  optional: 'ไม่บังคับ',
  enterStake: 'กรอกจำนวน (ไม่บังคับ)',
  handicap: 'แต้มต่อ',
  handicapSettings: 'ตั้งค่าแต้มต่อ',
  off: 'ปิด',
  on: 'เปิด',
  back: 'กลับ',
  start: 'เริ่มเกม',
  hole: 'หลุม',
  par: 'PAR',
  nextHole: 'ยืนยันและถัดไป',
  currentMoney: 'สถานะปัจจุบัน',
  poolBalance: 'ยอดคงเหลือ',
  holeTied: 'หลุมเสมอ',
  poolGrows: 'เงินหลุมถัดไป',
  skinsWinner: '{player} ชนะ Skin!',
  holeSettlement: 'สรุปหลุม',
  netScore: 'สุทธิ',
  rank: 'อันดับ {n}',
  winner: 'ผู้ชนะ',
  resume: 'เล่นต่อ',
  finishRound: 'ยืนยันและจบ',
  kaki: 'ก๊วนกอล์ฟ',
  kakiDeleteConfirm: 'ลบก๊วนกอล์ฟนี้?',
  confirmHoleScore: 'ยืนยันสกอร์หลุม {hole}',
  holeScoresSummary: 'สกอร์ผู้เล่น:',
  cancel: 'ยกเลิก',
  yes: 'ใช่',
  confirm: 'ยืนยัน',
  switchLang: 'ภาษา',
  noStake: 'กรุณากรอกจำนวนเดิมพัน',
  atLeast2: 'กรุณากรอกอย่างน้อย 2 ผู้เล่น',
  gameOver: 'จบเกม!',
  backToHome: 'กลับหน้าหลัก',
  out: 'ออก',
  in: 'เข้า',
  total: 'รวม',
  totalScore: 'คะแนนรวม',
  standardPar: 'Par',
  finalSettlement: 'สรุปสุดท้าย',
  noScoreData: 'ยังไม่มีสกอร์',
  f9: '9 หลุมแรก',
  b9: '9 หลุมหลัง',
  f18: '18 หลุมแรก',
  b18: '18 หลุมหลัง',
  f9Desc: 'หลุม 1-9',
  b9Desc: 'หลุม 10-18',
  f18Desc: 'มาตรฐาน 1-18',
  b18Desc: '10-18, 1-9',
  duplicateNames: 'ชื่อผู้เล่นต้องไม่ซ้ำ',
  screenshotHint: 'แนะนำให้จับภาพหน้าจอเพื่อบันทึกสกอร์',
  totalLoss: 'รวม',
  totalPar: 'PAR',
  noCourses: 'ไม่พบสนาม',
  trySearch: 'ลองใช้คำค้นอื่น',
  front9: '9 แรก',
  back9: '9 หลัง',
  eagle: 'Eagle',
  birdie: 'Birdie',
  parLabel: 'Par',
  bogey: 'Bogey',
  doubleplus: 'Double+',
  selectHoleToEdit: 'เลือกหลุมที่จะแก้ไข',
  holeJumpTitle: 'ข้ามไปยังหลุม',
  holeJumpReturnToast: 'เหลืออีก {n} หลุม — กลับไปที่หลุม {hole}',
  editHole: 'แก้ไข',
  save: 'บันทึก',
  scoreUpdated: 'อัปเดตสกอร์แล้ว คำนวณเงินใหม่แล้ว',
  matchPlayDesc: 'สุทธิต่ำสุดชนะ ผู้แพ้จ่ายเดิมพัน',
  win123Desc: 'ปรับตามอันดับ UP เพื่อเสี่ยง/รับรางวัล',
  skinsDesc: 'ทุกคนลงหลุม ต่ำสุดคนเดียวกวาด',
  baccaratDesc: 'แข่งตัวต่อตัว UP คูณเดิมพัน',
  reportTitle: ' รายงาน',
  scoreDistribution: 'การกระจายสกอร์',
  puttingAnalysis: 'วิเคราะห์พัตต์',
  totalPutts: 'พัตต์ทั้งหมด',
  avgPerHole: 'เฉลี่ย/หลุม',
  onePutt: 'พัตต์เดียว',
  threePutts: '3 พัตต์ขึ้นไป',
  holes: ' หลุม',
  penaltyStats: 'สถิติโทษ',
  waterHazard: 'น้ำ',
  stats: ' สถิติ',
  attempts: ' ครั้ง',
  times: '',
  holeByHole: 'รายหลุม',
  viewFullDetail: 'ดูรายละเอียดทั้งหมด',
  fullDetail: 'รายละเอียดทั้งหมด',
  strokes: ' สโตรก',
  putt: 'พัตต์',
  water: 'น้ำ',
  clickNameToView: 'แตะชื่อเพื่อดูรายละเอียด',
  confirmPutts: 'ยืนยันพัตต์',
  zeroPuttsWarning: 'ผู้เล่นต่อไปนี้มี 0 พัตต์:',
  puttsScore: 'สกอร์',
  puttsStrokes: '',
  puttsPutts: 'พัตต์',
  puttsTip: 'เคล็ดลับ: ยกเว้น chip-in พัตต์มักไม่เป็น 0',
  puttsGoBack: 'กลับแก้ไข',
  puttsConfirm: 'ยืนยัน',
  mpMultiplayer: 'หลายผู้เล่น',
  mpSync: 'ซิงค์หลายผู้เล่น',
  mpCodePlaceholder: 'รหัส',
  mpEnter6Digit: 'กรอกรหัส 4 หลัก',
  mpJoin: 'เข้าร่วม',
  mpPointQr: 'ชี้ไปที่ QR โค้ด',
  mpQrLoadFail: 'โหลด QR ไม่ได้',
  mpLinkCopied: 'คัดลอกลิงก์แล้ว!',
  mpCopyLink: 'คัดลอกลิงก์',
  mpShareLink: 'แชร์',
  startSolo: 'เริ่มเล่นคนเดียว',
  mpJumbo: 'จัมโบ้',
  mpCreateRoom: 'สร้างห้อง',
  mpWaitingPartner: 'รอเพื่อนร่วม',
  mpWaitingStart: 'รอเริ่ม',
  mpRoomCode: 'รหัสห้อง',
  mpCopied: 'คัดลอกแล้ว!',
  mpCopyCode: 'คัดลอกรหัส',
  mpScanToJoin: 'สแกนเพื่อเข้าร่วม',
  mpGameInfo: 'ข้อมูลเกม',
  mpCourse: 'สนาม',
  mpMode: 'โหมด',
  mpStake: 'เดิมพัน',
  mpRoom: 'ห้อง',
  mpPlayerAssignment: 'มอบหมายผู้เล่น',
  mpMine: 'ของฉัน',
  mpPartner: 'คู่แข่ง',
  mpUnclaimed: 'ยังไม่มีเจ้าของ',
  mpConnected: 'เชื่อมต่อแล้ว',
  mpError: 'ข้อผิดพลาด',
  mpConnecting: 'กำลังเชื่อมต่อ...',
  mpStartGame: 'เริ่มเกม',
  mpWaitingCreator: 'รอผู้สร้างเริ่มเกม...',
  mpClaimTitle: 'เลือกผู้เล่นของคุณ',
  mpClaimDesc: 'เลือกผู้เล่นที่คุณจะบันทึกสกอร์',
  mpSelectOne: 'เลือกอย่างน้อยหนึ่งผู้เล่น',
  mpConfirmClaim: 'ยืนยันการเลือก',
  mpConfirmSubmit: 'ยืนยัน',
  mpWaiting: 'กำลังรอ...',
  mpConfirmFinish: 'ยืนยันและจบ',
  mpConfirmNext: 'ยืนยันและถัดไป',
  mpAdvancedStats: 'โหมดสถิติขั้นสูง',
  mpHolesLabel: 'หลุม',
  hcpLabel: 'HCP',
  hideInfo: 'ซ่อน',
  learnMore: 'เรียนรู้เพิ่มเติม',
  close: 'ปิด',
  clearRecent: 'ล้าง',
  recentCourses: 'สนามล่าสุด',
  endGame: 'จบ',
  shareRoundReport: 'แชร์รายงานรอบ',
  allDataCleared: 'ข้อมูลเกมทั้งหมดจะถูกลบ',
  endGameConfirm: 'จบเกมตอนนี้?\nหลุมที่ไม่เสร็จจะไม่ถูกนับ',
  holeLabel: 'หลุม {n}',
  holeLabelShort: 'H{n}',
  cameraAccessDenied: 'ไม่สามารถเข้าถึงกล้อง',
  generateLinkFailed: 'สร้างลิงก์ไม่สำเร็จ',
  copyFailed: 'คัดลอกไม่สำเร็จ',
  retracted: 'ถอนแล้ว สามารถแก้ไขสกอร์ได้',
  matchPlayBubble: 'สุทธิต่ำสุดชนะแต่ละหลุม เสมอ? ไม่มีใครจ่าย',
  win123Bubble: 'จัดอันดับตามสุทธิ อันดับต่ำ = ค่าปรับมาก UP เพื่อเพิ่มเดิมพัน',
  skinsBubble: 'ต่ำสุดคนเดียวรับทั้งหมด เสมอ? สะสมไปหลุมถัดไป',
  baccaratBubble: '4 ผู้เล่น 6 คู่แข่ง เรียก UP เพิ่มเดิมพัน',
  mpSyncBubble: 'คุณบันทึกผู้เล่นคุณ เพื่อนบันทึกของเขา สกอร์ซิงค์อัตโนมัติ',
  hcpBubble: 'แต้มต่อ (0-36): ทำให้ผู้เล่นต่างระดับแข่งได้ยุติธรรม ระบบแจกสโตรกตามความยากของหลุมอัตโนมัติ',
  undoEdit: 'ยกเลิก & แก้ไข',
  waitingProceed: 'กำลังรอ {badge} ดำเนินการต่อ...',
  voiceWithHcp: '{player}, {on} on, {putt} {puttWord}, {handicap} handicap.',
  voiceNoHcp: '{player}, {on} on, {putt} {puttWord}.',
  voiceHoleIntro: 'หลุม {hole}, พาร์ {par}, อินเด็กซ์ {index}',
  voiceHoleIntroNoIdx: 'หลุม {hole}, พาร์ {par}',
  voiceHcpOnHole: '{player}, แต้มต่อ {strokes} สโตรก',
  ttsLang: 'th-TH',
  editLogTitle: 'บันทึกการแก้ไข',
  editLogHoleTitle: 'หลุม {n} บันทึกการแก้ไข',
  editLogEmpty: 'ไม่มีบันทึกการแก้ไข',
  editLogCount: '{n} การแก้ไข',
  editLogAllRecorded: 'บันทึกการแก้ไขทั้งหมดแล้ว',
  editLogScore: 'สกอร์',
  editLogPutts: 'พัตต์',
  editLogUp: 'UP',
  editNotifyTitle: 'สกอร์หลุม {n} ถูกแก้ไข',
  editNotifyBy: 'แก้ไขโดย {who}',
  editNotifyDetail: 'แตะเพื่อดูรายละเอียด',
  editLogTapHint: 'แตะบนหมายเลขหลุมเพื่อดูบันทึก',
  editLogClose: 'ปิด',
  // Viewer Mode
  mpRoleTitle: 'เข้าร่วมห้อง',
  mpRoleDesc: 'เลือกวิธีเข้าร่วม',
  mpPlayerRole: 'ผู้เล่น',
  mpPlayerRoleDesc: 'เลือกผู้เล่นและใส่คะแนน',
  mpPlayerTagInput: 'ใส่คะแนน',
  mpPlayerTagClaim: 'เลือกผู้เล่น',
  mpViewerRole: 'ผู้ชม',
  mpViewerRoleDesc: 'ดูเกมสด อ่านอย่างเดียว',
  mpViewerTagLive: 'คะแนนสด',
  mpViewerTagNoInput: 'ไม่สามารถป้อน',
  mpViewerBanner: 'ดูเท่านั้น — ไม่สามารถใส่คะแนน',
  mpViewerReminder: 'คุณกำลังดูเกมนี้',
  mpViewerReminderDesc: 'คะแนนอัปเดตแบบเรียลไทม์ คุณไม่สามารถป้อนหรือแก้ไขคะแนน',
  exit: 'ออก',
  // Scorecard Section
  scorecardHorizontal: 'แนวนอน',
  scorecardVertical: 'แนวตั้ง',
  shareBtn: 'แชร์',
  penalties: 'โทษ',
  // Feedback แสดงความคิดเห็น
  feedbackBtn: 'แสดงความคิดเห็น',
  feedbackTitle: 'แสดงความคิดเห็น',
  feedbackSubtitle: 'ช่วยเราปรับปรุง HandinCap',
  feedbackRateLabel: 'ให้คะแนนประสบการณ์',
  feedbackCatLabel: 'คุณอยากให้ปรับปรุงอะไร? (เลือกได้หลายข้อ)',
  feedbackCatNewModes: 'โหมดเกมใหม่',
  feedbackCatUI: 'หน้าจอ/เลย์เอาต์',
  feedbackCatSpeed: 'ความเร็ว/ประสิทธิภาพ',
  feedbackCatCourse: 'ข้อมูลสนาม',
  feedbackCatScoring: 'การนับคะแนน',
  feedbackCatMultiplayer: 'หลายผู้เล่น',
  feedbackCatBug: 'รายงานบัก',
  feedbackCatOther: 'อื่นๆ',
  feedbackCommentPlaceholder: 'บอกเราว่าคุณคิดอย่างไร...\nเช่น อยากได้โหมด Nassau',
  feedbackSubmit: 'ส่งความคิดเห็น',
  feedbackSubmitting: 'กำลังส่ง...',
  feedbackThanks: 'ขอบคุณ!',
  feedbackThanksDetail: 'เราอ่านทุกความคิดเห็น',
  feedbackSkip: 'ไว้ทีหลัง',
  feedbackStar1: 'แย่',
  feedbackStar2: 'พอใช้',
  feedbackStar3: 'ดี',
  feedbackStar4: 'ดีมาก',
  feedbackStar5: 'ยอดเยี่ยม!',
  // Share page
  shareInvalidLink: 'ลิงก์ไม่ถูกต้อง',
  shareInvalidDesc: 'ลิงก์แชร์นี้ไม่ถูกต้องหรือหมดอายุ',
  shareGoTo: 'ไปที่ HandinCap',
  poweredBy: 'ขับเคลื่อนโดย',
  onLabel: 'On',
  avg: 'เฉลี่ย',
  totalLabel: 'รวม',
  // Multiplayer extras
  mpConnectionStatus: 'สถานะการเชื่อมต่อ',
  mpPlayersJoined: 'ผู้เล่นเข้าร่วม',
  mpViewersJoined: 'ผู้ชมเข้าร่วม',
  mpNoPlayersYet: 'ยังไม่มีผู้เล่นเข้าร่วม คุณยังสามารถเริ่มได้ — คุณจะบันทึกสกอร์ผู้เล่นทั้งหมดเอง',
  mpProcessing: 'กำลังประมวลผล...',
  mpClaimed: 'ถูกเลือกแล้ว',
  mpNoPlayers: 'ไม่มีผู้เล่น',
  ob: 'OB',
  allConfirmed: 'ทั้งหมดยืนยันแล้ว',
  liveSyncing: 'ซิงค์สด',
  justNow: 'เมื่อสักครู่',
  minsAgo: '{n}นาทีที่แล้ว',
  hrsAgo: '{n}ชั่วโมงที่แล้ว',
  roomNotFound: 'ไม่พบห้อง',
  // Round Report
  rrTitle: 'รายงานรอบ',
  rrGolfCourse: 'สนามกอล์ฟ',
  rrTotalScorePar: 'คะแนนรวม (Par: {n})',
  rrShareImage: 'แชร์รูปภาพ',
  rrShareLink: 'แชร์ลิงก์',
  rrImageDownloaded: 'ดาวน์โหลดรูปภาพแล้ว',
  rrImageFailed: 'สร้างรูปภาพไม่สำเร็จ',
  rrScreenshotFailed: 'จับภาพหน้าจอไม่สำเร็จ กรุณาจับภาพด้วยตนเอง',
  rrOpenApp: 'เปิด HandinCap',
  loading: 'กำลังโหลด...',
};

export default th;
